<template>
  <div>
    <table-header
      search
      search-placeholder="Cari berdasarkan produk"
      search-action="giftProducts/getGiftProducts"
      :actions="['buttonAdd', 'buttonMore']"
    />

    <b-skeleton-table
      v-if="isLoading"
      :rows="5"
      :columns="5"
    />
    <b-table
      v-else
      ref="refGiftProductListTable"
      :items="giftProducts.data"
      responsive
      :fields="tableFields"
      show-empty
      empty-text="Tidak ada data yang ditemukan"
      class="position-relative mh-160"
    >
      <!-- Column: Nama -->
      <template #cell(name)="data">
        <b-media
          v-if="data.item.product"
          vertical-align="center"
        >
          <template #aside>
            <b-img
              rounded
              width="50"
              :src="linkStaging(data.item.product.images[0].image_url, 50, 50)"
              alt="Product Image"
              @error="(event) => {
                event.target.src = require('@/assets/images/icons/broken-image.svg')
              }"
            />
          </template>
          <span class="font-weight-bold d-block">
            {{ data.item.product.name }}
          </span>
          <small class="text-muted">by {{ data.item.owner.name }}</small>
        </b-media>
      </template>

      <!-- Column: Price -->
      <template #cell(variant)="data">
        <span
          v-if="data.item.variant.variant"
          class="text-nowrap"
        >
          {{ data.item.variant.variant }}
        </span>
        <span
          v-else-if="data.item.variant.sku_name"
          class="text-nowrap"
        >
          {{ data.item.variant.sku_name }}
        </span>
        <i
          v-else
          class="text-nowrap text-secondary"
        >Tanpa Nama</i>
      </template>

      <!-- Column: Price -->
      <template #cell(price)="data">
        <span class="text-nowrap">
          {{ toCurrency(data.item.variant.price) }}
        </span>
      </template>

      <!-- Column: Payment Progress -->
      <template #cell(payment_progress)="data">
        <span class="text-nowrap">
          {{ toCurrency(data.item.payment_progress) }}
        </span>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <div class="text-nowrap">
          <table-action
            :actions="tableAction"
            :data="data"
          />
        </div>
      </template>

    </b-table>
    <!-- Footer -->
    <div class="mx-2 mb-2">
      <pagination
        :data="giftProducts.meta"
        action="giftProducts/getGiftProducts"
      />
    </div>

    <b-modal
      v-model="isShowEditVariant"
      title="Ubah Variant"
      hide-footer
      centered
    >
      <div v-if="activeGiftProduct">
        <div>{{ activeGiftProduct.product.name }}</div>
        <hr>
        <b-row>
          <b-col
            xl="3"
            md="4"
            sm="12"
            class="font-weight-bold"
          >
            Variant Dihapus:
          </b-col>
          <b-col
            xl="9"
            md="8"
            sm="12"
          >
            <span
              v-if="activeGiftProduct.variant.variant"
              class="text-nowrap"
            >
              {{ activeGiftProduct.variant.variant }}
            </span>
            <span
              v-else-if="activeGiftProduct.variant.sku_name"
              class="text-nowrap"
            >
              {{ activeGiftProduct.variant.sku_name }}
            </span>
            <i
              v-else
              class="text-nowrap text-secondary"
            >Tanpa Nama</i>
            ({{ toCurrency(activeGiftProduct.variant.price) }})
          </b-col>
        </b-row>

        <validation-observer ref="simpleRules">
          <b-form
            class="mt-2"
            @submit.prevent="submitUpdateVariant"
          >
            <b-row>
              <b-col md="12">
                <b-form-group
                  label="Variant Pengganti"
                  label-for="alternative-variant"
                  description="Catatan: Pastikan memilih variant yang paling mendekati"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Variant Pengganti"
                    rules="required"
                  >
                    <b-form-select
                      id="alternative-variant"
                      v-model="selectedAlternativeVariantId"
                      :options="alternativeVariants"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col
                md="12"
                class="text-right"
              >
                <hr class="mt-0">

                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1 mb-1"
                  :disabled="isLoading"
                >
                  <b-spinner
                    v-show="isLoading"
                    small
                  />
                  Simpan
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import {
  BModal,
  BForm,
  BFormGroup,
  BTable, BRow, BCol,
  BMedia, BImg, BSkeletonTable, BButton, BSpinner,
  BFormSelect,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'

import Pagination from '@/layouts/components/custom/Pagination.vue'
import TableAction from '@/layouts/components/custom/TableAction.vue'
import TableHeader from '@/layouts/components/custom/TableHeader.vue'

export default {
  components: {
    BSkeletonTable,
    BModal,
    BTable,
    BForm,
    BFormGroup,
    BRow,
    BCol,
    BMedia,
    BImg,
    BButton,
    BSpinner,
    BFormSelect,
    ValidationProvider,
    ValidationObserver,
    Pagination,
    TableAction,
    TableHeader,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      tableFields: [
        { key: 'name', label: 'Produk' },
        { key: 'variant', label: 'Variant (Dihapus)' },
        { key: 'price', label: 'Harga' },
        { key: 'payment_progress', label: 'Payment' },
        { key: 'actions', label: '', thStyle: { width: '1%' } },
      ],

      activeGiftProduct: '',
      selectedAlternativeVariantId: '',

      required,
    }
  },
  computed: {
    ...mapState('giftProducts', ['giftProducts', 'isLoading']),
    query() {
      return this.$route.query
    },
    isShowEditVariant: {
      get() {
        return this.$store.state.giftProducts.isShowEditVariant
      },
      set(value) {
        this.$store.commit('giftProducts/SET_OPEN_EDIT', value)
      },
    },
    alternativeVariants() {
      return [
        { value: '', text: 'Harap pilih' },
        ...this.activeGiftProduct.alternative_variants.map(item => {
          let text = ''
          if (item.variant) text = item.variant
          else if (item.sku_name) text = item.sku_name
          else text = 'Tanpa Nama'

          text = `${text} (${this.toCurrency(item.price)})`

          return { value: item.id, text }
        }),
      ]
    },
    tableAction() {
      return [
        {
          access: null,
          to: null,
          action: data => { this.toExternalLink(`/registry/${data.owner.username}/${data.id}`) },
          icon: 'EyeIcon',
          title: 'Lihat Produk',
        },
        {
          access: this.canAccess('manage', 'Product'),
          to: null,
          action: data => { this.changeGiftProduct(data) },
          icon: 'EditIcon',
          title: 'Pilih Variant Pengganti',
        },
      ]
    },
  },
  async created() {
    if (!this.giftProducts.data.length) {
      await this.getGiftProducts(this.query)
    }
  },
  methods: {
    ...mapActions('giftProducts', ['getGiftProducts', 'updateVariant']),
    async handlePagination(page) {
      await this.getGiftProducts({ page })
    },
    changeGiftProduct(value) {
      this.selectedAlternativeVariantId = ''

      this.activeGiftProduct = value
      this.isShowEditVariant = true
    },
    submitUpdateVariant() {
      this.$refs.simpleRules.validate().then(async success => {
        if (success) {
          await this.updateVariant({ skuId: this.activeGiftProduct.id, alternativeSkuId: this.selectedAlternativeVariantId, query: this.$route.query })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
